(() => {
  const reducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    new URLSearchParams(window.location.search).get('motion') === 'reduce';

  const initReducedMedia = (root) => {
    if (!reducedMotion()) return;
    root.querySelectorAll('img[data-reduced-src]').forEach((image) => {
      if (!image.dataset.motionSrc) image.dataset.motionSrc = image.currentSrc || image.src;
      image.src = image.dataset.reducedSrc;
    });
  };

  const initGallery = (root) => {
    root.querySelectorAll('[data-swris-gallery]').forEach((gallery) => {
      if (gallery.dataset.swrisGalleryReady === 'true') return;
      const main = gallery.querySelector('[data-swris-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-swris-gallery-thumb]')];
      const previous = gallery.querySelector('[data-swris-gallery-prev]');
      const next = gallery.querySelector('[data-swris-gallery-next]');
      if (!main || !thumbs.length) return;
      gallery.dataset.swrisGalleryReady = 'true';
      let current = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));

      const activate = (index, focus = false) => {
        current = (index + thumbs.length) % thumbs.length;
        const selected = thumbs[current];
        main.src = selected.dataset.imageSrc;
        main.alt = selected.dataset.imageAlt || '';
        main.style.objectPosition = selected.dataset.imagePosition || 'center center';
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === current;
          thumb.classList.toggle('is-selected', active);
          thumb.setAttribute('aria-selected', String(active));
          thumb.tabIndex = active ? 0 : -1;
          if (active && focus) thumb.focus();
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activate(index));
        thumb.addEventListener('keydown', (event) => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') activate(0, true);
          else if (event.key === 'End') activate(thumbs.length - 1, true);
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') activate(index - 1, true);
          else activate(index + 1, true);
        });
      });
      previous?.addEventListener('click', () => activate(current - 1, true));
      next?.addEventListener('click', () => activate(current + 1, true));
      document.addEventListener('shopify:block:select', (event) => {
        const selected = thumbs.find((thumb) => thumb.dataset.galleryBlockId === event.detail?.blockId);
        if (selected) activate(thumbs.indexOf(selected));
      });
    });
  };

  const initStagedReviews = (root) => {
    root.querySelectorAll('[data-swris-review-load-more]').forEach((button) => {
      if (button.dataset.swrisReviewReady === 'true') return;
      const scope = button.closest('.swris-voices') || root;
      const stagedReviews = [...scope.querySelectorAll('[data-swris-review-item].is-staged')];
      if (!stagedReviews.length) {
        button.hidden = true;
        return;
      }
      button.dataset.swrisReviewReady = 'true';
      button.addEventListener('click', () => {
        stagedReviews.forEach((review) => review.classList.add('is-revealed'));
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
      });
    });
  };

  const init = (root = document) => {
    initReducedMedia(root);
    initGallery(root);
    initStagedReviews(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
